import { useToast } from 'primevue/usetoast'
import { ROUTES } from '../routeNames'
import { resolveRequiredPermissionRedirect } from './requiredPermission'

export default function auth({ to, next, store }) {
  // Allow unauthenticated access to demo mode
  if (to.params.teamPid === 'demo') {
    return next()
  }

  const authStore = useAuthStore()
  const toast = useToast()

  authStore
    .getUser()
    .then(async () => {
      const requiredPermission = to.meta.requiredPermission
      const normalizedTeamPid = Array.isArray(to.params.teamPid)
        ? to.params.teamPid[0]
        : to.params.teamPid

      if (
        typeof requiredPermission === 'string'
        && normalizedTeamPid
      ) {
        const parsedTeamPid = Number.parseInt(normalizedTeamPid, 10)

        if (Number.isFinite(parsedTeamPid)) {
          const configStore = useConfigStore()
          const needsPermissionContextHydration =
            configStore.currentTeamPid !== parsedTeamPid
            || configStore.currentTeam?.pid !== parsedTeamPid
            || !configStore.owner

          if (needsPermissionContextHydration) {
            configStore.currentTeamPid = parsedTeamPid
            await configStore.configQuery.refetch()
          }
        }
      }

      const { canAccess } = usePermissionStore()
      const redirect = resolveRequiredPermissionRedirect(
        requiredPermission,
        canAccess,
        to.params.teamPid as string | string[] | undefined
      )

      if (redirect) {
        toast.add({
          severity: 'warn',
          summary: 'Access required',
          detail: `${to.meta.title ?? 'This page'} is not available for this account.`,
          life: 4000
        })
        next(redirect)
        return
      }

      next()
    })
    .catch(() => {
      const safePath = to.fullPath.startsWith('/') ? to.fullPath : '/'
      // Don't add redirect=/ since the HOME route just redirects to dashboard anyway.
      // Including it causes an infinite loop: postLogin() sees redirect=/ → pushes to /
      // → beforeEnter calls postLogin() again with stale route query → loop.
      const query = safePath !== '/' ? { redirect: safePath } : {}
      next({ name: ROUTES.LOGIN, query })
    })
}
